<script>
  import { onMount } from "svelte";
  import { msghistory, msg, messages } from "../stores.js";
  import { push, replace, location } from 'svelte-spa-router';

  export let params = {};

  let message = "";

  onMount(async () => {
    if (params.num) {
      const parsed = parseInt(params.num, 10);
      if (!isNaN(parsed)) {
        message = $msghistory[parsed - 1];
        if (!message) push("/");
      } else {
        message = $messages.error;
      }
    } else {
      message = $msg ? $msg : $messages.error;
      $msg = "";
      if ($msghistory.length === 0) {
        $msghistory.push(message);
      } else {
        if ($msghistory[$msghistory.length - 1] != message) {
          $msghistory.push(message);
        }
      }
      replace($location + "/" + $msghistory.length);
    }
  });
</script>

<div class="mt-1 mb-1">
<p class="ws-pl">{message}</p>
</div>